import { useAuthStore } from '@/stores/authStore'
import type { GetCurrentUserResponse } from '@/types/api'

export function useCurrentUser(): { data: GetCurrentUserResponse | undefined; isLoading: boolean; isError: boolean; error: null } {
  const data = useAuthStore((s) => s.currentUser ?? undefined)
  const isLoading = useAuthStore((s) => s.isLoading)
  return { data, isLoading, isError: false, error: null }
}
